export default __webpack_public_path__ + "static/media/DaciaBlock-Bold.0e6cf3d4.woff";